import { useEffect, useRef } from "react";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;
export const TURNSTILE_ENABLED = !!SITE_KEY;

let scriptPromise = null;
function loadTurnstileScript() {
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve) => {
    if (window.turnstile) return resolve();
    const s = document.createElement("script");
    s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    s.async = true;
    s.defer = true;
    s.onload = () => resolve();
    document.head.appendChild(s);
  });
  return scriptPromise;
}

export const Turnstile = ({ onVerify, action, resetSignal = 0, theme = "light" }) => {
  const ref = useRef(null);
  const widgetId = useRef(null);

  useEffect(() => {
    if (!SITE_KEY) return;
    let cancelled = false;
    loadTurnstileScript().then(() => {
      const tryRender = (attempt = 0) => {
        if (cancelled || widgetId.current) return;
        if (window.turnstile && ref.current) {
          widgetId.current = window.turnstile.render(ref.current, {
            sitekey: SITE_KEY,
            action,
            theme,
            callback: (t) => onVerify(t),
            "expired-callback": () => onVerify(""),
            "error-callback": () => onVerify(""),
          });
        } else if (attempt < 25) {
          setTimeout(() => tryRender(attempt + 1), 150);
        }
      };
      tryRender();
    });
    return () => {
      cancelled = true;
      if (widgetId.current && window.turnstile) {
        try { window.turnstile.remove(widgetId.current); } catch (e) {}
        widgetId.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Reset the widget (Turnstile tokens are single-use) after a failed submit.
  useEffect(() => {
    if (resetSignal > 0 && widgetId.current && window.turnstile) {
      try { window.turnstile.reset(widgetId.current); } catch (e) {}
      onVerify("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetSignal]);

  if (!SITE_KEY) return null;
  return <div ref={ref} className="mt-1 flex justify-center" data-testid="turnstile-widget" />;
};
